import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { provideNgxMask } from 'ngx-mask';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {
  PU_CONFIG,
  PU_TOAST_CONFIG,
  PU_TOAST_DEFAULT_CONFIG,
  SPINNER_COMPONENT,
} from '@pinup-teams/common';
import { environment } from '@fb/environments';

import { CdkOverlayContainer } from './services/overlay/overlay-container';
import { authInterceptor } from './services/auth/auth.interceptor';
import { TranslateLoaderService } from './services/translation/translate-loader.service';
import { TranslationPathService } from './services/translation/translation-path.service';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { refreshTokenInterceptor } from './services/auth/refresh-token.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    { provide: OverlayContainer, useClass: CdkOverlayContainer },
    provideNgxMask(),
    provideHttpClient(
      withInterceptors([authInterceptor, refreshTokenInterceptor]),
    ),
    provideAnimations(),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useClass: TranslateLoaderService,
          deps: [HttpClient],
        },
      }),
    ),
    TranslationPathService,
    { provide: LOCALE_ID, useValue: 'en' },
    {
      provide: PU_TOAST_CONFIG,
      useValue: PU_TOAST_DEFAULT_CONFIG,
    },
    {
      provide: PU_CONFIG,
      useValue: {
        apiHost: environment.apiHost,
        useMocks: environment.useMocks,
        production: environment.production,
        mfePrefix: environment.assetsUrl,
      },
    },
    {
      provide: SPINNER_COMPONENT,
      useValue: SpinnerComponent,
    },
    {
      provide: PU_CONFIG,
      useValue: { useNewIcons: true },
    },
  ],
};
